(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["get-inspired-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gi-grid [data-player]').forEach((player) => {
    if (player.dataset.init === 'true') return;
    player.dataset.init = 'true';

    const button = player.querySelector('[data-player-btn]');
    if (!button) return;

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const type = player.dataset.type;
      let html = '';

      if (type === 'video') {
        const src = player.dataset.src;
        html = `<video class="gi-grid__video" controls autoplay playsinline preload="metadata"><source src="${src}" type="video/mp4"></video>`;
      } else if (type === 'youtube') {
        const id = player.dataset.id;
        html = `<iframe class="gi-grid__iframe" src="https://www.youtube.com/embed/${id}?autoplay=1&controls=1&modestbranding=1&rel=0&playsinline=1" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      } else if (type === 'vimeo') {
        const id = player.dataset.id;
        html = `<iframe class="gi-grid__iframe" src="https://player.vimeo.com/video/${id}?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      }

      if (!html) return;

      player.classList.add('is-playing');
      const temp = document.createElement('div');
      temp.innerHTML = html;
      player.appendChild(temp.firstChild);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      if (!section) return;

      const rail = section.querySelector('[data-logo-rail]');
      const quote = section.querySelector('[data-logo-quote]');
      const items = Array.from(section.querySelectorAll('[data-logo-item]'));
      if (!rail || !quote || !items.length) return;

      let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
      let autoplayTimer = null;

      const setActive = (index, shouldScroll = true) => {
        activeIndex = index;
        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const nextQuote = items[index].dataset.quote || '';
        quote.style.opacity = '0';
        window.setTimeout(() => {
          quote.textContent = nextQuote ? `"${nextQuote}"` : '';
          quote.style.opacity = '1';
        }, 120);

        if (shouldScroll) {
          items[index].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      };

      const startAutoplay = () => {
        if (section.dataset.autoplayDisabled === 'true' || items.length < 2) return;
        stopAutoplay();
        autoplayTimer = window.setInterval(() => {
          const nextIndex = (activeIndex + 1) % items.length;
          setActive(nextIndex, true);
        }, 3000);
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      items.forEach((item, index) => {
        item.addEventListener('click', () => {
          setActive(index, true);
          startAutoplay();
        });
      });

      rail.addEventListener('mouseenter', stopAutoplay);
      rail.addEventListener('mouseleave', startAutoplay);
      rail.addEventListener('focusin', stopAutoplay);
      rail.addEventListener('focusout', startAutoplay);

      setActive(activeIndex, false);
      startAutoplay();
    };

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[id^="LogoWithText-"]').forEach(initSection);
    });

    document.addEventListener('shopify:section:load', (event) => {
      initSection(event.target.querySelector('[id^="LogoWithText-"]') || event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
